@if (liveOption?.enabled) {
  <div class="nodes-current-date">{{currentDisplayedTime}}</div>
}
<div #map id="map" class="google-map"></div>
@if (showFloors && floorLevels.length > 1) {
  <div class="floor-level-container">
    <ul>
      @for (level of floorLevels; track level.floor) {
        <li (click)="changeFloorLevel(level)" [class.selected]="selectedFloorLevel === level.floor"> {{level.floor}} </li>
      }
    </ul>
  </div>
}
@if (showPlayOption && !loading) {
  <div class="video-progressbar-wrap d-flex">
    <span class="control-btn" (click)="startPlay()">
      <span class="material-symbols-outlined">
        {{isPlaying ? 'pause' : 'play_arrow'}}
      </span>
    </span>
    @if (dustLayer.length) {
      <div class="progress" [class.scrollable]="dustLayer.length > 30">
        @for (value of dustLayer; track trackByIndex(i); let i = $index) {
          <div class="progress-bar" role="progressbar"
            [style]="'width: calc('+100/dustLayer.length+'% - 1px)'"
            [class.selected]="currentKmlIndex != null && i === currentKmlIndex"
            [class.overflowed]="dustLayer.length > 30"
            [attr.aria-valuenow]="'width: calc('+100/dustLayer.length+'% - 1px)'" aria-valuemin="0"
            aria-valuemax="100" (click)="showKmlFile(i)">
            <span class="progress-value">{{value.currTime}}</span>
            @if (i == 0 || value.currDate != dustLayer[i-1].currDate) {
              <span class="progress-date">{{value.currDate }}</span>
            }
          </div>
        }
      </div>
    }
    <div class="date">
      <span>{{dustLayer[currentKmlIndex || 0].currDate + ' | ' +  dustLayer[currentKmlIndex || 0].currTime}}</span>
    </div>
  </div>
}
@if (loading) {
  <div class="spinner-outer">
    <div class="spinner-cover">
      <div class="spinner-section">
        <mat-progress-spinner [color]="spinnerColor" [diameter]="spinnerDiameter" [mode]="spinnerMode"
        [strokeWidth]="spinnerStrokeWidth" [value]="spinnerValue"></mat-progress-spinner>
      </div>
    </div>
  </div>
}
